/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_6_Chatbot_DescInputs */

const en_privacy_section_6_chatbot_desc = /** @type {(inputs: Privacy_Section_6_Chatbot_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not stored on our servers; processed in real-time by OpenAI subject to their data retention policies`)
};

const lv_privacy_section_6_chatbot_desc = /** @type {(inputs: Privacy_Section_6_Chatbot_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`netiek glabātas mūsu serveros; OpenAI tās apstrādā reāllaikā saskaņā ar savu datu glabāšanas politiku`)
};

/**
* | output |
* | --- |
* | "not stored on our servers; processed in real-time by OpenAI subject to their data retention policies" |
*
* @param {Privacy_Section_6_Chatbot_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_6_chatbot_desc = /** @type {((inputs?: Privacy_Section_6_Chatbot_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_6_Chatbot_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_6_chatbot_desc(inputs)
	return en_privacy_section_6_chatbot_desc(inputs)
});